import { Modal } from 'src/components/modals/comps';
import styled, { css } from 'styled-components';

export const StyledModal = styled(Modal)<{ $slideHeight: number; $width?: 1100 | 1400 }>`
  width: ${({ $width }) => $width || 1100}px;
  padding-left: 0;
  padding-right: 0;
  display: flex;
  max-height: calc(100% - 40px);
  overflow-y: auto;
  transition: width 0.3s;
  padding-bottom: 0;

  .children {
    flex: 1;
    overflow-x: hidden;
  }

  .wm {
    flex: 1;
    display: flex;
    flex-direction: column;
    position: relative;

    &__top {
      /* border: 1px solid red; */
    }
    &__content {
      /* border: 1px solid green; */
      flex: 1;
      display: flex;
      margin-bottom: 10px;
    }
    &__bottom {
      /* border: 1px solid blue; */
    }
  }

  .err-container {
    /* position: absolute; */
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    /* bottom: 10px; */
    width: 100%;
    transform: translateY(15px);
  }

  .keen-slider__slide {
    overflow: hidden;
    min-height: ${({ $slideHeight }) => $slideHeight}px;
  }

  ${({ theme }) => theme.breakpoints.up('md')} {
    .compact-input {
      &.MuiTextField-root {
        & input,
        textarea {
          font-size: 14px;
          padding-top: 12px;
          padding-bottom: 12px;
        }
        & input::placeholder,
        textarea::placeholder {
          font-size: 14px;
        }
      }

      &.cydea-select {
        font-size: 14px;
        height: 40px;

        .cydea-select__control {
          height: 40px;
        }
        .cydea-select__option {
          font-size: 14px;
          padding: 0 10px;
        }
        .cydea-select__group-heading {
          font-size: 14px;
        }
        .cydea-select__placeholder {
          font-size: 14px;
        }
      }

      &.add-controls-btn {
        height: 34px;
        min-width: 100px;
        padding: 1px 0.8rem;
        font-size: 14px;
      }
    }
    .ms-value-container {
      height: 40px;
      padding: 0 20px;
    }
  }
`;

export const GridContainer = styled.div<{ $large?: boolean; $scenarios?: boolean }>`
  display: grid;
  grid-gap: ${({ $large }) => ($large ? 16 : 6)}px;
  .row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    grid-gap: 12px;
    &__title {
      height: 100%;
      padding-top: 8px;
    }
    &__end {
      width: 225px;
      min-width: 225px;

      &--checkbox {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        grid-gap: 6px;
      }

      &__add-controls {
        flex: 1;
        display: flex;
        align-items: center;
      }
    }
  }

  ${({ theme }) => theme.breakpoints.down('md')} {
    grid-gap: ${({ $large }) => ($large ? 10 : 6)}px;
    .row {
      &__end {
        width: 150px;
        min-width: 150px;
      }
    }
  }
  ${({ theme }) => theme.breakpoints.down('sm')} {
    grid-gap: ${({ $large }) => ($large ? 8 : 4)}px;
    .row {
      &__title {
        padding-top: 10px;
      }
      &__end {
        width: 120px;
        min-width: 120px;
      }
    }
  }

  ${({ $scenarios }) =>
    $scenarios &&
    css`
      .row {
        &__end {
          width: 40px;
          min-width: 40px;
        }
      }
    `}
`;
